<template>
  <div class="game-input-on-background-wrapper" :style="getStyle(startGameConfig)">
    <div
      v-for="(image, index) in imageData"
      :key="'image_' + index"
      class="main-image-container"
      :style="getImageStyle(image)"
    ></div>
    <div
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
      v-html="item.text"
    ></div>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      :style="getBoxStyle(startGameConfig.boxConfig)"
      class="box-style"
    ></tr-box>
    <tr-input
      v-for="(item, index) in items"
      :id="item.id"
      :key="item.id"
      :config="item"
      :tr-input-value="inputData[index]"
      :input-width="item.inputWidth || startGameConfig.inputWidth"
      :input-height="item.inputHeight || startGameConfig.inputHeight"
      :input-font-size="item.inputFontSize || startGameConfig.inputFontSize"
      :max-length="item.inputMaxLength || startGameConfig.inputMaxLength"
      :style="getCustomStyle(item)"
    ></tr-input>
  </div>
</template>

<script>
import _ from 'lodash';
import TrInput from '../TrInput/TrInput';
import TrBox from '../../GameBaseElements/TrBox/TrBox';
import * as utils from '../../Utils/inputUtils';
import defaultMixin from '../../mixins/defaultMixin';
import inputMixin from '../../mixins/inputMixin';
import { log } from 'util';
export default {
  name: 'tr-input-on-background',
  components: {
    TrInput,
    TrBox,
  },
  mixins: [inputMixin, defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      words: [],
      boxConfig: {
        x: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.left) || 1,
        y: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.top) || 14,
        width: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.width) || 98,
        height: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.height) || 12,
        unit: '%',
      },
      inputData: [],
      staticText: [],
      imageData: [],
    };
  },
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.items = this.prepareData(this.startGameConfig.items);
      this.inputData = _.map(this.items, (item) => {
        return {
          correct: item.correct,
          val: item.value || '',
          block: item.block || false,
          inputStatus: item.inputStatus || null,
          caseSensitive: item.caseSensitive || this.caseSensitive,
          coupled: item.coupled,
          mathematica: item.mathematica,
          replace: item.replace,
        };
      });

      this.longestWordLength = _.maxBy(this.inputData, (item) => {
        if (item.correct && _.isArray(item.correct)) {
          return item.correct.length;
        }
        return false;
      });
    },
    getMainImage(baseConfig) {
      return baseConfig.mainImage;
    },
    getAllImage(items) {
      let mainImage = this.getMainImage(this.startGameConfig);
      let filterItems = _.map(_.filter(items, 'imageData'), (item) => {
        return item.imageData;
      });
      return _.isObject(mainImage) ? _.compact([mainImage, ...filterItems]) : _.compact(filterItems);
    },
    processData(node, staticText, imageArray) {
      if (node.items) {
        // if(status.lengt>0){}
        if (node.pick && node.shuffle) {
          node.items = _.sampleSize(_.cloneDeep(node.items), node.pick);
        } else if (node.pick) {
          node.items = _.take(_.cloneDeep(node.items), node.pick);
        }
        if (node.shuffle) {
          node.items = _.shuffle(node.items);
        }
        if (node.staticText) {
          staticText.push(node.staticText);
        }
        if (node.imageData) {
          imageArray.push(node.imageData);
        }
        return _.flattenDeep(
          _.map(node.items, (item) => {
            return this.processData(item, staticText, imageArray, node);
          })
        );
      }
      // let status = _.filter(node.items, 'staticIndex');
      if (node.staticText) {
        staticText.push(node.staticText);
      }
      if (node.imageData) {
        imageArray.push(node.imageData);
      }
      return node;
    },
    prepareData() {
      let staticText = [];
      let imageArray = [];
      let pick = this.startGameConfig.pick;
      let data = _.cloneDeep(this.startGameConfig.items);
      let staticIndexArray = _.filter(data, (item) => {
        return !_.isNil(item['staticIndex']);
      });
      if (staticIndexArray.length > 0) {
        pick = this.startGameConfig.pick - staticIndexArray.length;
        data = _.difference(data, staticIndexArray);
      }
      if (
        this.startGameConfig.items &&
        this.startGameConfig.pick &&
        _.isNumber(this.startGameConfig.pick) &&
        this.startGameConfig.pick > 0 &&
        this.startGameConfig.shuffle
      ) {
        data = _.sampleSize(_.cloneDeep(data), pick);
      } else if (
        this.startGameConfig.items &&
        this.startGameConfig.pick &&
        !_.isNumber(this.startGameConfig.pick) &&
        this.startGameConfig.shuffle
      ) {
        data = _.sampleSize(_.cloneDeep(data));
      } else if (this.startGameConfig.items && data.picks && _.isArray(data.picks)) {
        let counter = 0;
        data = _.flattenDeep(
          _.map(_.omit(data, ['picks']), (element) => {
            if (_.isArray(element) && data.picks && data.picks[counter]) {
              return _.flattenDeep(
                _.map(_.sampleSize(_.cloneDeep(element), data.picks[counter++]), (elem) => {
                  return [...elem.items];
                })
              );
            } else if (_.isArray(element)) {
              return [...element.items];
            }
          })
        );
      } else if (this.startGameConfig.items && pick) {
        data = _.take(_.cloneDeep(data), pick);
      } else if (this.startGameConfig.items && this.startGameConfig.shuffle) {
        data = _.shuffle(data);
      }
      _.each(staticIndexArray, (item) => {
        data.push(item);
      });
      data = _.flattenDeep(
        _.map(data, (item) => {
          return this.processData(item, staticText, imageArray, this.startGameConfig);
        })
      );
      /**
       * get image from first layer processed items
       * @type {Array.<Object>}
       */
      // this.imageData = this.getAllImage({ data });
      this.imageData = imageArray;
      if (this.startGameConfig.mainImage) {
        this.imageData.unshift(this.startGameConfig.mainImage);
      } else if (this.startGameConfig.background) {
        this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
      }
      /** add static text */
      if (this.startGameConfig.staticText) {
        if (
          this.startGameConfig.staticText[0] &&
          this.startGameConfig.staticText[0].items &&
          this.startGameConfig.staticText[0].items.length > 0
        ) {
          if (this.startGameConfig.staticText[0].pick) {
            staticText = _.map(this.startGameConfig.staticText, (elem) => {
              return _.take(_.cloneDeep(elem.items), elem.pick);
            });
            staticText = _.flatten(staticText);
            // staticText.push(_.sampleSize(_.cloneDeep(staticText[0].items), staticText[0].pick));
          }
        }
        staticText = this.startGameConfig.staticText;
      }

      this.staticText = _.map(staticText, (item, index) => {
        if (this.startGameConfig.layoutStaticText) {
          return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
        } else {
          return item;
        }
      });

      /**
       * add layout for items if exist
       * @method if
       * @param  {array} this.startGameConfig.layoutItems layoutItems array
       * @return {Boolean}
       */
      if (this.startGameConfig.layoutItems) {
        this.items = _.map(_.cloneDeep(this.items), (item, index) => {
          return Object.assign(item, this.startGameConfig.layoutItems[index]);
          // return _.merge( item, this.startGameConfig.layoutItems[ index ] );
        });
      }
      let tail = _.cloneDeep(this.imageData);
      let head;
      /**
       * add layout for images if exist
       * @method if
       * @param  {array} this.startGameConfig.layoutImages layoutImages array
       * @return {Boolean}
       */
      if (this.startGameConfig.layoutImages) {
        /** if first elementr is mainImage don't applay layout to him */
        if (this.startGameConfig.mainImage) {
          head = this.imageData[0];
          tail = _.tail(tail);
        }
        /** rest of array */
        tail = _.map(_.cloneDeep(tail), (item, index) => {
          return Object.assign(item, this.startGameConfig.layoutImages[index]);
        });
      }
      if (this.startGameConfig.mainImage) {
        this.imageData = [head, ...tail];
      } else {
        this.imageData = tail;
      }
      this.imageData = _.compact(this.imageData);

      this.textItem = _.map(_.cloneDeep(data), (item, index) => {
        if (this.startGameConfig.layoutItems && this.startGameConfig.layoutItems[index]) {
          return _.defaultsDeep(item, _.cloneDeep(this.startGameConfig.layoutItems[index]));
        }
        return item;
      });
      /**
       * add words box to game
       */
      if (this.startGameConfig.words) {
        let syncData = this.startGameConfig.boxConfig.syncData;
        this.words = this.startGameConfig.words;
        if (this.startGameConfig.boxConfig && syncData) {
          this.words = _.intersection(
            this.startGameConfig.words,
            _.flattenDeep(
              _.map(this.textItem, (item) => {
                if (item[syncData]) {
                  return [...item[syncData]];
                } else if (item.markers) {
                  return _.flattenDeep(
                    _.map(item.markers, (item) => {
                      return [...item[syncData]];
                    })
                  );
                }
                return [...item[syncData]];
              })
            )
          );
        }
        this.words = _.shuffle(this.words);
      }
      return _.cloneDeep(this.textItem);
      // return _.map(this.items, (item, key) => {
      //   if (key != 'pick' || key != 'shuffle') {
      //     return item;
      //   }
      // });
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
      // this.questionsList = this.processQuestionsList();
    },
    checkGameAction() {
      return this.inputOnBackgroundCheckGameAction();
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      } else {
        return '';
      }
      return _.merge({ position: 'absolute' }, this.getCustomStyle(imageData), {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        // 'position': 'absolute',
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getBoxStyle(box) {
      // box.x = _box.x;
      // box.y = _box.y;
      // box.width = box.width;
      // box.height = box.height;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(box), {
        // 'position': 'absolute',
        left: utils.elementLeftPosition(box.x, 0, '%'),
        top: utils.elementTopPosition(box.y, 0, '%'),
        width: utils.elementWidth(box.width, '%'),
        height: utils.elementHeight(box.height, '%'),
      });
    },
    getStyle(item) {
      let width = '1920px';
      let height = '1080px';
      if (item && item.cssStyle) {
        (width = item.cssStyle.width || width), (height = item.cssStyle.height || height);
      }
      return _.merge({}, { width: width, height: height }, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function(value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    caseSensitive() {
      return this.startGameConfig.caseSensitive;
    },
    maxCharNumber() {
      return _.round((this.longestWordLength.correct.length * 120) / 100).toString();
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
    boxConfigFontSize() {
      let fontSize = this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.fontSize;
      return fontSize + 'px';
    },
  },
};
</script>

<style lang="scss" scoped>
.game-input-on-background-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  position: inherit;
  // background-image: url("~@/assets/icons/przybornik_kosz.png");
  .main-image-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;

    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
